<template>
    <div class="company-bar flex justify-between border-b border-solid border-gray-40 bg-white px-6 pb-4 pt-6">
        <CompanyBarSkeleton v-if="isLoading" />

        <template v-else-if="companyInfo">
            <div class="flex items-center gap-4">
                <SolutionOrgIcon class="solution-org-icon h-16 w-16" :org-info-logo="companyInfo.logo"/>
                <div class="flex flex-col gap-3">
                    <div class="text-2xl font-semibold">
                        {{ companyInfo.name }}

                        <div class="th-tooltip th-tooltip-bottom-start ml-3 cursor-pointer text-sm font-normal text-primary before:max-w-[550px] before:text-left" v-if="companyInfo.description" :data-tip="companyInfo.description">
                            {{ t('desc') }}
                        </div>
                    </div>

                    <div class="flex items-center text-xs text-[#8993a4]">
                        <div v-for="(info, idx) in companyTitle" :key="idx" class="flex items-center">
                            <div class="h-2.5 border-l border-[#DFE1E6] pl-2.5" v-if="idx !== 0" />
                            <div class="inline-block pr-2.5">
                                {{ info }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ml-4 flex items-center gap-2" v-if="isShowSubCompanyBtn">
                <input
                    type="checkbox"
                    @change="updateCheckedChild"
                    :disabled="isLoading"
                    :checked="checkedChild"
                    class="th-checkbox"
                />
                <span class="text-sm text-grey-450">
                    {{ t('includeSubsidiary') }}
                </span>
            </div>
        </template>
    </div>

</template>

<script setup lang="ts">
import { useCompanyBasic } from '@/composables/use-company-basic'
import CompanyBarSkeleton from '@/components/CompanyBarSkeleton.vue'
import { useGlobalState } from '@/composables/use-global-store';
import { useI18n } from 'vue-i18n'
import { SolutionOrgIcon } from '@eureka/solution-card';
import '@patsnap-ui/icon/assets/solid/AddMedium.svg'
import '@patsnap-ui/icon/assets/solid/ArrowLeft.svg'
import { onMounted } from 'vue';

const { t } = useI18n()

const { companyInfo, isShowSubCompanyBtn, isLoading, companyTitle, getCompanyInfo } = useCompanyBasic()
const { updateCheckedChild, checkedChild } = useGlobalState()
onMounted(() => {
    getCompanyInfo()
})
</script>
<style lang="scss" >
.company-bar {
    .solution-org-icon {
        svg{
            width: 32px;
            height: 32px;
        }
    }
}
</style>
